import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import bg from '../locales/bg.json';
import en from '../locales/en.json';

const resources = {
    bg: {
        translation: bg,
    },
    en: {
        translation: en,
    },
};

i18next.use(initReactI18next).init({
    lng: 'bg',
    resources,
});

export default i18next;
